import Axios from "./axios";

const endpoint = "/api/file";

export default {
  //qr코드 다운로드
  //{"qrString": "string"}
  qrCodeDownload: (data) =>
    Axios({
      url: `${endpoint}/download-qr`,
      data: data,
      responseType: "blob",
      method: "POST",
    }),

  //{"orderId": "Number"}
  /**
   *
   * @param {Number} orderId
   * @param {Number} orderHistoryId
   * @returns
   */
  cadDownload: (data) =>
    Axios({
      url: `${endpoint}/download-cad`,
      data: data,
      responseType: "blob",
      method: "POST",
    }),

  orderStyleDown: (data) =>
    Axios({
      url: `${endpoint}/download-orderstyle`,
      data: data,
      responseType: "blob",
      method: "POST",
    }),

  invoiceStyleDown: (data) =>
    Axios({
      url: `${endpoint}/download-invoicestyle`,
      data: data,
      responseType: "blob",
      method: "POST",
    }),

  /**
   * 발주입고 엑셀
   * @param {Number} constructionId	현장 번호
   * @param {Text} type	타입
   * @param {Text} keyword	검색 조건
   * @param {Text} startDate	시작 날짜
   * @param {Text} endDate	종료 날짜
   * @param {Text} order	정렬 순서
   * @returns
   */
  orderInvoiceDown: (data) =>
    Axios({
      url: `${endpoint}/download-orderinvoice-status`,
      data: data,
      responseType: "blob",
      method: "POST",
    }),

  /**
   * 발주 엑셀
   * @param {Number} constructionId	현장 번호
   * @param {Text} type	타입
   * @param {Text} keyword	검색 조건
   * @param {Text} startDate	시작 날짜
   * @param {Text} endDate	종료 날짜
   * @param {Text} order	정렬 순서
   * @returns
   */
  orderDown: (data) =>
    Axios({
      url: `${endpoint}/download-order-status`,
      data: data,
      responseType: "blob",
      method: "POST",
    }),

  /**
   * 출고 엑셀
   * @param {Number} constructionId	현장 번호
   * @param {Text} type	타입
   * @param {Text} keyword	검색 조건
   * @param {Text} startDate	시작 날짜
   * @param {Text} endDate	종료 날짜
   * @param {Text} order	정렬 순서
   * @returns
   */
  invoiceDown: (data) =>
    Axios({
      url: `${endpoint}/download-invoice-status`,
      data: data,
      responseType: "blob",
      method: "POST",
    }),

  /**
   * 입고 엑셀
   * @param {Number} constructionId	현장 번호
   * @param {Text} type	타입
   * @param {Text} keyword	검색 조건
   * @param {Text} startDate	시작 날짜
   * @param {Text} endDate	종료 날짜
   * @param {Text} order	정렬 순서
   * @returns
   */
  completeDown: (data) =>
    Axios({
      url: `${endpoint}/download-complete-status`,
      data: data,
      responseType: "blob",
      method: "POST",
    }),

  //cad 업로드
  //cadfile
  cadUpload: (data) =>
    Axios({ url: `${endpoint}/upload-cad`, data: data, method: "POST" }),

  uploadParsingCad: (data) =>
    Axios({
      url: `${endpoint}/upload-parsing-cad`,
      data: data,
      method: "POST",
    }),

  fileMoveCad: (data) =>
    Axios({ url: `${endpoint}/move-cad`, data: data, method: "POST" }),

  /**
   * 통계자료 다운로드
   * @param {*} constructionId 현장번호 not null
   * @param {*} selectDate 선택일
   * @param {*} startDate 시작일
   * @param {*} endDate 종료일
   */
  statisticsDown: (data) =>
    Axios({
      url: `${endpoint}/download-statistics-list`,
      data: data,
      method: "POST",
      responseType: "blob",
    }),
};
